import { useCallback, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import moment from "moment-timezone";
import env from "../../../config/env";
import { useUsersContext } from "../../../context/usersContext";
import { useUserInfo } from "../../../context/user";

const useRunTask = () => {
  const BASE_URL = `${env.API_URL}/v1`;
  const { createConvesation, fetchChats } = useUsersContext();
  const [userInfo, , , , userActiveLocation] = useUserInfo();
  const [running, setRunning] = useState(false);


  const runTask = useCallback(
    async (task) => {
      const taskOutput = (task?.output || "chatUi").toString().toLowerCase();
      const taskPrompt = task?.prompt_value || "";

      if (!taskPrompt) {
        toast.error("This task does not have prompt content to run.");
        return;
      }

      setRunning(true);
      try {
        if (taskOutput === "chatui") {
          await createConvesation({
            title: task?.title,
            message: taskPrompt,
            messagetype: "notimage",
            addInMessages: true,
            assistant_model_name: "openai/gpt-4o",
          });
          return;
        }

        const timeZone = moment.tz.guess() || "UTC";

        const response = await axios.post(
          `${BASE_URL}/prompts/messaging`,
          {
            profile_id: userActiveLocation?.id,
            user_id: userInfo?.userId,
            provider_id: task?.output,
            message: taskPrompt,
            channel_id: task?.channel,
            ...(task?.integration_id != null
              ? { integration_id: task.integration_id }
              : {}),
            title: task?.title,
            timezone: timeZone,
          },
          { timeout: 100000 },
        );

        if (response?.data?.data?.message) {
          toast.success(response.data.data.message);
        }

        await fetchChats();
      } catch (error) {
        console.error("Error running task:", error);
        toast.error(
          error?.response?.data?.message ||
          "Something went wrong while running the task.",
        );
      } finally {
        setRunning(false);
      }
    },
    [
      BASE_URL,
      createConvesation,
      fetchChats,
      userActiveLocation?.agency_id,
      userActiveLocation?.id,
      userInfo?.userId,
    ],
  );

  return { runTask, running };
};

export default useRunTask;
